// Copyright (c) 2017 Deere & Company

import AuditList from '../state/audit-list';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateAuditList = (state, action) =>
    AuditList.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().auditList, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_AUDIT_LIST]: updateAuditList
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/audits/reducers/audit-list.js